module.exports = __webpack_public_path__ + "img/whatsapp.3e3afbd5.jpg";